import React from 'react';
import { Virtuoso } from 'react-virtuoso';

import { MCButton, Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, permissions } from 'src/helpers';

import TimelineItem from './item';
import { JourneyList } from './Journey/list';
import { popupModel, ForwardModal } from 'src/components/complex';
import CreateTimeline from './create';
import { BASE_ICONS } from '../svg';
import { ReplyModal } from 'src/components/complex/contact/ReplyModal';
import AlertManager from 'src/components/alert';
import LANG_CONST from 'src/helpers/lang/const';

const { ACTIONS, PAGES } = permissions;

class Timeline extends BaseComponent {
  componentDidMount() {
    this.props.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  onReply = (item) => {
    let { model } = this.props;
    popupModel.setActivePopup('reply', {
      active: true,
      component: ReplyModal,
      props: {
        onSubmit: (text, hide) => {
          model.emit('replyOrForwardedMsg', {
            partnerId: item.from,
            originalMsg: {
              ...item,
              msgType: 'timeline',
              text,
              data: { ...item.data, timelineId: item.id }
            },
            type: 'reply'
          });
          this.navigate(PAGES.MESSAGES_USER_PAGE.match(item.from));
          hide();
        }
      }
    });
  };
  onForward = (item) => {
    let { model } = this.props;
    popupModel.setActivePopup('forward', {
      active: true,
      component: ForwardModal,
      props: {
        onSelect: (user, hide) => {
          model.emit('replyOrForwardedMsg', {
            partnerId: user.id,
            partner: user,
            originalMsg: {
              ...item,
              msgType: 'timeline',
              data: { ...item.data, timelineId: item.id }
            },
            type: 'forward'
          });
          this.navigate(PAGES.MESSAGES_USER_PAGE.match(user.id));
          hide();
        }
      }
    });
  };

  onDelete = (item) => {
    let { model } = this.props;
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          model.remove(item.id, () => {
            actions.hide();
            actions.setLoading(false);
          });
        }
      }
    });
  };

  render() {
    let {
      model,
      fromChat = false,
      showCategory = true,
      enableAdd = true,
      selectJourney,
      journeyId,
      journeys,
      journey,
      forAll
    } = this.props;

    const items = this.props.loading ? [] : model.items();
    const loading = model.refreshing() || this.props.loading;
    let searchQuery = model.listInput('search');
    let noResults = this.props.loading ? false : model.noResults();

    return (
      <div className={' mc-timeline'}>
        <Virtuoso
          className={'mc-virtuoso-list'}
          components={{
            Header: () => (
              <>
                {showCategory && (
                  <JourneyList
                    forAll={forAll}
                    model={model}
                    journeys={journeys}
                    journeyId={journeyId}
                    journey={journey}
                    selectJourney={selectJourney}
                  />
                )}
                {enableAdd && ACTIONS.ENTRY_ADD_BUTTON.isActive && (
                  <MCButton
                    large
                    primary
                    radius
                    dark
                    iconname={BASE_ICONS.PLUS}
                    className={'mc-ml20'}
                    onClick={() => {
                      popupModel.setActivePopup(ACTIONS.ENTRY_ADD_BUTTON.key, {
                        active: true,
                        component: CreateTimeline,
                        props: { model, journey }
                      });
                    }}
                    label={'New Entry'}
                  />
                )}
                {showCategory || enableAdd ? <div className={'mc-mb30'}></div> : null}
              </>
            ),
            Footer: () => (
              <>
                {(noResults || loading) && (
                  <div style={{ textAlign: 'center', padding: '1rem' }}>
                    {noResults && !searchQuery && (
                      <div>{lang.t(LANG_CONST.text.no_results_yet)}</div>
                    )}
                    {noResults && searchQuery && <div>{lang.t(LANG_CONST.text.nothing_found)}</div>}
                  </div>
                )}
                <div style={{ textAlign: 'center' }}>{loading && <Spinner />}</div>
              </>
            )
          }}
          data={items}
          endReached={() => {
            if (model.hasMore() && !model.refreshing()) model.loadMore();
          }}
          itemContent={(index, item) => (
            <TimelineItem
              auth={model.state.user}
              items={items}
              item={item}
              index={index}
              title={item.text}
              description={item.data}
              date={item.date}
              id={item.id}
              media={item.media}
              fromChat={fromChat}
              journey={journeys && journeys[0]}
              key={'mc-analyse-list-item-' + item.id}
              onReply={() => this.onReply(item)}
              onForward={() => this.onForward(item)}
              onDelete={() => this.onDelete(item)}
              onLike={() => {
                model.like(item, (error, data) => {
                  if (
                    !error &&
                    data.from !== model.state.user.id &&
                    data.likedUserIds.indexOf(model.state.user.id) > -1
                  )
                    this.onReply(item);
                });
              }}
              onEdit={() => {
                popupModel.setActivePopup('add_timeline', {
                  active: true,
                  component: CreateTimeline,
                  props: { model, item }
                });
              }}
            />
          )}
        />
      </div>
    );
  }
}

export default Timeline;
